export const NumberInput = ({ value, handleOnChange, placeholder }) => (
    <input
        className={`w-full text-center h-10 leading-tight border-b-2 focus:outline-none focus:border-lighter-blue-green hover:border-lighter-blue-green focus:outline-none`}
        value={value}
        placeholder={placeholder}
        onChange={handleOnChange}
    />
)
